'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gregorianCalendarFormatLibLocaleZhCn = require('gregorian-calendar-format/lib/locale/zh-cn');

var _gregorianCalendarFormatLibLocaleZhCn2 = _interopRequireDefault(_gregorianCalendarFormatLibLocaleZhCn);

exports['default'] = {
  today: '今天',
  now: '此刻',
  ok: '确定',
  clear: '清除',
  previousMonth: '上个月 (翻页上键)',
  nextMonth: '下个月 (翻页下键)',
  monthSelect: '选择月份',
  yearSelect: '选择年份',
  decadeSelect: '选择年代',
  hourInput: '上一小时(上方向键), 下一小时(下方向键)',
  minuteInput: '上一分钟(上方向键), 下一分钟(下方向键)',
  secondInput: '上一秒(上方向键), 下一小时(下方向键)',
  hourPanelTitle: '选择小时',
  minutePanelTitle: '选择分钟',
  secondPanelTitle: '选择秒',
  yearFormat: 'yyyy\'年\'',
  monthFormat: 'M\'月\'',
  dateFormat: 'yyyy\'年\'M\'月\'d\'日\'',
  previousYear: '上一年 (Control键加左方向键)',
  nextYear: '下一年 (Control键加右方向键)',
  previousDecade: '上一年代',
  nextDecade: '下一年代',
  previousCentury: '上一世纪',
  nextCentury: '下一世纪',
  format: _gregorianCalendarFormatLibLocaleZhCn2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-calendar/lib/locale/zh-cn.js
 ** module id = 134
 ** module chunks = 0 1
 **/